module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "col-12 col-sm-6 mb-2"
  }, [_c('img', {
    ref: "img",
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.src
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79c9bfb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/ImageItem.vue
// module id = 88
// module chunks = 1 2